import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TranslationService } from 'src/app/core/services/translation.service';

@Component({
  selector: 'app-no-data',
  templateUrl: './no-data.component.html',
  styleUrls: ['./no-data.component.scss'],
  imports: [TranslateModule]
})
export class NoDataComponent {
  @Input() item: any = 'ui_data_lbl';
  constructor(private translatePipe: TranslationService) {
    if (this.item == 'ui_data_lbl') {
      this.item = this.translatePipe.translateMethod('ui_data_lbl');
    }
  }
}
